"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Arrow = function Arrow(_ref) {
  var _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].arrow,
    onClick: onClick
  }, expanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null));
};
Arrow.propTypes = {
  expanded: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
var _default = exports["default"] = Arrow;